import * as React from 'react';
import {Component, deps, inject, observer} from '../lib/component';
import {PlayButtonCompat} from '../components/compat/play-button-compat';
import {AddRemoveCompat} from '../components/compat/add-remove-compat';
import {style} from 'typestyle';
import {centerCenter} from 'csstips';
import {important, percent, px} from 'csx';
import {FavouriteButtonCompat} from '../components/compat/favourite-button-compat';
import {PageHomeJustAdded} from '../components/page-home-just-added';
import {PageHomeSections} from '../components/page-home-sections';
import {PageHomePricing} from '../components/page-home-pricing';
import {PricingCalculator} from '../components/pricing-calculator';
import {PageHomeCreators} from '../components/page-home-creators';
import {animationBounce} from '../theme/animation';
import {transitionQuickEase} from '../theme/transition';
import {colorContrast, colorSubtle, colorWhite} from '../theme/color';
import {mediaTablet} from '../theme/media';
import {zHeroContent} from '../theme/z';
import MainWrapper from '../components/main-wrapper';
import HeroSearch from '../components/hero/search';
import {GenericCarousel} from "../components/page-home-generic-carousel";

@inject(deps) @observer
export class HomePage extends Component<{}> {
  render() {
    const { model, controller } = this.props;
    const { home } = model.page;
    const {
      loading,
      justAdded = [],
      endingSoon = [],
      homepageThirdCarousel = [],
      homepageFourthCarousel = [],
      homepageFifthCarousel = [],
      homepageSixthCarousel = [],
      homepageSeventhCarousel = []
    } = home;
    const { preloadImage, preloadContent, preloadRaw } = this.props.controller.image;
    const { user } = this.props.model.auth;
    const { handleClickLink, handleClickSignIn } = this.props.controller.ui;
    
    const showFirstFree = !!model.content.firstUseCoupon
      && !model.user.user || model.checkout.isBeta;

    return (
      <MainWrapper>
        <div className={HomePage.styles.content}>
          <HeroSearch
            defaultSuggestions={home.heroSuggestions}
          />
          {!loading && justAdded.length > 0 && (
            <PageHomeJustAdded
              model={home}
              PlayButton={PlayButtonCompat}
              AddRemove={AddRemoveCompat}
              Favourite={FavouriteButtonCompat}
              onClickLink={handleClickLink}
              preload={preloadImage}
              i18n={{title: model.content.homepageFirstTitle}}
            />
          )}
          {!loading && endingSoon.length > 0 && (
            <GenericCarousel
              tracks={endingSoon}
              PlayButton={PlayButtonCompat}
              AddRemove={AddRemoveCompat}
              Favourite={FavouriteButtonCompat}
              onClickLink={handleClickLink}
              preload={preloadImage}
              i18n={{title: model.content.homepageSecondTitle}}
            />
          )}
          {!loading && homepageThirdCarousel.length > 0 && (
              <GenericCarousel
                  tracks={homepageThirdCarousel}
                  PlayButton={PlayButtonCompat}
                  AddRemove={AddRemoveCompat}
                  Favourite={FavouriteButtonCompat}
                  onClickLink={handleClickLink}
                  preload={preloadImage}
                  i18n={{title: model.content.homepageThirdCarouselTitle}}
              />
          )}
          {!loading && homepageFourthCarousel.length > 0 && (
              <GenericCarousel
                  tracks={homepageFourthCarousel}
                  PlayButton={PlayButtonCompat}
                  AddRemove={AddRemoveCompat}
                  Favourite={FavouriteButtonCompat}
                  onClickLink={handleClickLink}
                  preload={preloadImage}
                  i18n={{title: model.content.homepageFourthCarouselTitle}}
              />
          )}
          {!loading && homepageFifthCarousel.length > 0 && (
              <GenericCarousel
                  tracks={homepageFifthCarousel}
                  PlayButton={PlayButtonCompat}
                  AddRemove={AddRemoveCompat}
                  Favourite={FavouriteButtonCompat}
                  onClickLink={handleClickLink}
                  preload={preloadImage}
                  i18n={{title: model.content.homepageFifthCarouselTitle}}
              />
          )}
          {!loading && homepageSixthCarousel.length > 0 && (
              <GenericCarousel
                  tracks={homepageSixthCarousel}
                  PlayButton={PlayButtonCompat}
                  AddRemove={AddRemoveCompat}
                  Favourite={FavouriteButtonCompat}
                  onClickLink={handleClickLink}
                  preload={preloadImage}
                  i18n={{title: model.content.homepageSixthCarouselTitle}}
              />
          )}
          {!loading && homepageSeventhCarousel.length > 0 && (
              <GenericCarousel
                  tracks={homepageSeventhCarousel}
                  PlayButton={PlayButtonCompat}
                  AddRemove={AddRemoveCompat}
                  Favourite={FavouriteButtonCompat}
                  onClickLink={handleClickLink}
                  preload={preloadImage}
                  i18n={{title: model.content.homepageSeventhCarouselTitle}}
              />
          )}
          <PageHomeSections
            model={home}
            preload={preloadImage}
            preloadRaw={preloadRaw}
          />
          {showFirstFree && (
            <div className={HomePage.styles.firstFree} onClick={handleClickSignIn}>
              <div>
                <h5>{model.content.firstUseCoupon.title}</h5>
                <p>{model.content.firstUseCoupon.message}</p>
              </div>
            </div>
          )}
          <PageHomePricing
            model={home}
            preload={preloadContent}
            onClickLink={handleClickLink}
            onClickShowCalculator={this.handleHidePricing}
            onSelectRateType={controller.page.home.selectRateType}>
            {!home.showPricingGrid && (
              <PricingCalculator
                className={HomePage.styles.pricingCalculator}
                model={model.pricing}
                inverted={true}
                onClickLink={handleClickLink}
                onSearch={controller.pricing.search}
                onSubmit={controller.pricing.submit}
                onChangeQuery={controller.pricing.changeQuery}
                onChangeCurrency={controller.pricing.changeCurrency}
                onSignUp={user ? void 0 : handleClickSignIn}
                onShowPricing={this.handleShowPricing}
                onSelectRateType={controller.pricing.selectRateType}
              />
            )}
          </PageHomePricing>
          <PageHomeCreators preload={preloadImage} model={home} i18n={{ title: home.creatorsTitle, view_cta: home.creatorsViewCTA }} />
        </div>
      </MainWrapper>
    )
  }

  handleShowPricing = (event: React.MouseEvent<any>) => {
    event.preventDefault();
    this.props.controller.page.home.showPricingGrid();
  };

  handleHidePricing = (event: React.MouseEvent<any>) => {
    event.preventDefault();
    this.props.controller.page.home.hidePricingGrid();
  };

  componentWillMount() {
    this.props.controller.pricing.reset();
  }

  componentWillUnmount() {
    this.props.controller.page.home.destroyCarousel();
    this.props.controller.page.home.disposer();
  }
  
  static styles = {
    content: style({
      zIndex: zHeroContent,
      position: 'relative',
      color: colorSubtle.toString(),
    }),
    firstFree: style(
      {
        ...centerCenter,
        padding: '40px 20px',
        $nest: {
          '& > div': {
            ...animationBounce,
            cursor: 'pointer',
            transition: `all ${transitionQuickEase}`,
            width: percent(100),
            padding: px(20),
            background: colorContrast.toString(),
            borderRadius: px(20),
            color: colorWhite.toString(),
          },
          '& > div:hover': {
            background: colorContrast.darken(0.15).toString(),
          },
          '& h5': {
            color: colorWhite.toString(),
            margin: 0,
            fontSize: px(24)
          },
          '& p': {
            margin: '20px 0 0',
            fontSize: px(20)
          }
        },
      },
      mediaTablet({
        margin: '40px auto',
        maxWidth: px(640),
        padding: '30px 60px',
        $nest: {
          '&> div': {
            padding: px(30)
          },
          '& h5': {
            color: colorWhite.toString(),
            margin: 0,
            fontSize: px(30)
          },
          '& p': {
            margin: '30px 0 0',
            fontSize: px(22)
          }
        }
      })
    ),
    pricingCalculator: style(
      mediaTablet({ padding: important('0 80px') })
    )
  }
}